import { DOUBLE_DASH } from 'consts/placeholders';
import Timeline, { TimelineItem } from 'lib/Timeline';
import { DetailedInventoryAsset } from 'components/common/types/DetailedInventoryAsset.types';

import TagInfo from './TagInfo';
import { Button as ReadMoreButton } from '../ReadMoreSections';

type TagsProps = {
  tags?: DetailedInventoryAsset['tags'];
  toggleReadMore?: () => void;
  maxRecordsToShow: number;
};

const Tags = ({ tags = [], toggleReadMore = (): null => null, maxRecordsToShow }: TagsProps): React.ReactElement => {
  return (
    <div>
      <h2 className="sub-header-base mb-8">Tags</h2>
      <div className="pl-2" data-test-id="tag-container">
        <Timeline>
          {tags.length ? (
            <TagInfo tagGroup={tags.slice(0, maxRecordsToShow)} />
          ) : (
            <TimelineItem title={<p className="body-base">{DOUBLE_DASH}</p>} />
          )}
        </Timeline>
        {tags.length > 3 ? <ReadMoreButton onClick={toggleReadMore} /> : null}
      </div>
    </div>
  );
};

export default Tags;
